import React from "react";
import Media from "react-media";
import { Link } from "react-router-dom";

export default function Slide(props) {
    const { image, image2, programId } = props;
    return (
        <>
            <Media
                query="(max-width: 768px)"
                render={() => (
                    <div
                        className="main-header"
                        style={{ backgroundImage: `url(${image2})` }}
                    >
                        <SlideContent {...props} />
                    </div>
                )}
            />

            <Media
                query="(min-width: 768px)"
                render={() => (
                    <div
                        className="main-header"
                        style={{ backgroundImage: `url(${image})` }}
                    >
                        <SlideContent {...props} />
                    </div>
                )}
            />
        </>
    );
}

function SlideContent(props) {
    const {
        title,
        subtitle,
        onClickSlide,
        buttonText,
        buttonColor,
        buttonBgColor,
        showButton,
        programId
    } = props;

    return (
        <div className="row content">
            <div className="col-md-9 col-xs-12 col-sm-8 right">
                <h1 className="title">{title}</h1>
                <span className="location">{subtitle}</span>
                {showButton && (
                    <Link
                        to={`/program/${programId}`}
                        style={{
                            backgroundColor: buttonBgColor || "#C62828",
                            color: buttonColor || "#fff",
                            border: "none"
                        }}
                        // onClick={e => {
                        //     e.preventDefault();
                        //     onClickSlide();
                        // }}
                        className="btn btn--lg btn--primary"
                    >
                        {buttonText || "آشنایی با دوره و ثبت نام"}
                    </Link>
                )}
            </div>
        </div>
    );
}
